/* =====================================================================
 * Main Form
 * ===================================================================*/

import helpers from '../helpers.js';
import calc from '../simulator/calc.js';

(function (doc) {

  const app = doc.querySelector('#app');
  if (!app) return;

  /* ---------------------------------------------------------------------
   * 1. Helpers
   * -------------------------------------------------------------------*/

  const getInputs = () => app.querySelectorAll('.input:not([readonly]), .select');
  const addNotice = (element, message) => helpers.addNotice(element, message);
  const removeNotice = (element) => helpers.removeNotice(element);

  /* ---------------------------------------------------------------------
   * 2. Base Position Calculation
   * -------------------------------------------------------------------*/

  const calcBasePosition = (dataRow) => {
    const inputs = dataRow.querySelectorAll('.input');
    const values = {};
    Array.prototype.forEach.call(inputs, (input) => {
      values[input.name] = input.value;
    });

    const calculate = calc.basePosition;
    const ctcCalcio = calculate.ctcCalcio(values['input-ca'], values['input-ctc']);
    const ctcMagnesio = calculate.ctcMagnesio(values['input-mg'], values['input-ctc']);

    return {
      res_amostra: values['input-amostra'],
      res_mmol_calcio: values['input-ca'],
      res_ctc_calcio: ctcCalcio,
      res_teor_calcio: calculate.teorCalcio(ctcCalcio),
      res_mmol_magnesio: values['input-mg'],
      res_ctc_magnesio: ctcMagnesio,
      res_teor_magnesio: calculate.teorMagnesio(ctcMagnesio),
      res_camg: calculate.camg(values['input-ca'], values['input-mg']),
      res_vone: values['input-v-one']
    };
  };

  const updateBasePosition = (dataRow, resultString) => {
    const results = calcBasePosition(dataRow);

    Object.keys(results).forEach((value) => {
      resultString = resultString.split(value).join(results[value]);
    });

    return resultString;
  };

  /* ---------------------------------------------------------------------
   * 3. Correctives Calculation
   * -------------------------------------------------------------------*/

  const calcCorrectives = (dataRow) => {
    const inputs = dataRow.querySelectorAll('.input');
    const values = {};
    Array.prototype.forEach.call(inputs, (input) => {
      values[input.name] = input.value;
    });

    return {
      res_amostra: values['input-amostra'],
      res_ctc: values['input-ctc'],
      res_vone: values['input-v-one'],
      res_vtwo: values['input-v-two']
    };
  };

  const updateCorrectives = (dataRow, resultString) => {
    const results = calcCorrectives(dataRow);

    Object.keys(results).forEach((value) => {
      resultString = resultString.split(value).join(results[value]);
    });

    return resultString;
  };

  /* ---------------------------------------------------------------------
   * 4. Estimated Position Calculation
   * -------------------------------------------------------------------*/

  const calcEstimatedPosition = (dataRow) => {
    const inputs = dataRow.querySelectorAll('.input');
    const values = {};
    Array.prototype.forEach.call(inputs, (input) => {
      values[input.name] = input.value;
    });

    return {
      res_amostra: values['input-amostra'],
    };
  };

  const updateEstimatedPosition = (dataRow, resultString) => {
    const results = calcEstimatedPosition(dataRow);
    Object.keys(results).forEach((value) => {
      resultString = resultString.split(value).join(results[value]);
    });

    return resultString;
  };

  /* ---------------------------------------------------------------------
   * 5. Validate Inputs
   * -------------------------------------------------------------------*/

  ['click', 'keyup'].forEach((eventType) => {
    doc.addEventListener(eventType, () => {
      const target = event.target;
      if (target.classList.contains('input') || target.classList.contains('select')) {

        if (target.readOnly || !helpers.getParentByClass(target, 'app')) return;

        target.addEventListener('blur', () => {
          const value = target.value;

          if (target.type === 'number') {
            target.value = helpers.numberFix(value, 2);
          }

          if (value) return;
          addNotice(target.parentNode, 'Preencha este campo.');
        });

        target.addEventListener('input', () => {
          removeNotice(target.parentNode);

          const currentRow = target.parentNode.parentNode.parentNode;

          const dataSB = [];
          const dataCTC = [];
          const dataVONE = [];

          const rowInputs = currentRow.querySelectorAll('.input');
          Array.prototype.forEach.call(rowInputs, (input) => {
            const value = Number(input.value);
            if (!value) return;

            if (input.classList.contains('input-k')) {
              dataSB.push(value);
              dataCTC.push(value);
              dataVONE.push(value);
            }

            if (input.classList.contains('input-ca')) {
              dataSB.push(value);
              dataCTC.push(value);
              dataVONE.push(value);
            }

            if (input.classList.contains('input-mg')) {
              dataSB.push(value);
              dataCTC.push(value);
              dataVONE.push(value);
            }

            if (input.classList.contains('input-hal')) {
              dataCTC.push(value);
            }
          });

          const calcInput = calc.inputCalc;

          if (dataSB.length === 3) {
            const inputSB = currentRow.querySelector('.input-sb');
            inputSB.value = calcInput.sb(...dataSB);
          }

          if (dataCTC.length === 4) {
            const inputCTC = currentRow.querySelector('.input-ctc');
            const valueCTC = calcInput.ctc(...dataCTC);
            inputCTC.value = valueCTC;
            dataVONE.push(valueCTC);
          }

          if (dataVONE.length === 4) {
            const inputVONE = currentRow.querySelector('.input-v-one');
            inputVONE.value = calcInput.vone(...dataVONE);
          }
        });
      }
    });
  });

  /* ---------------------------------------------------------------------
   * 6. Get Results HTML
   * -------------------------------------------------------------------*/

  const basePosition = doc.querySelector('.basePosition-result');
  const basePositionHTML = basePosition.innerHTML;
  // basePosition.innerHTML = '';

  const estimatedPosition = doc.querySelector('.estimatedPosition-result');
  const estimatedPositionHTML = estimatedPosition.innerHTML;
  // estimatedPosition.innerHTML = '';

  const correctives = doc.querySelector('.correctives-result');
  const correctivesHTML = correctives.innerHTML;
  // correctives.innerHTML = '';

  const updateResults = () => {
    const results = doc.querySelector('.appResult');
    const appData = app.querySelectorAll('.app-data');

    Array.prototype.forEach.call(appData, (dataRow) => {
      const basePositionResults = doc.createElement('tr');
      basePositionResults.className = 'basePosition-result';
      basePositionResults.innerHTML = updateBasePosition(dataRow, basePositionHTML);
      basePosition.parentNode.appendChild(basePositionResults);

      const correctivesResults = doc.createElement('tr');
      correctivesResults.className = 'correctives-result';
      correctivesResults.innerHTML = updateCorrectives(dataRow, correctivesHTML);
      correctives.parentNode.appendChild(correctivesResults);

      const estimatedPositionResults = doc.createElement('tr');
      estimatedPositionResults.className = 'estimatedPosition-result';
      estimatedPositionResults.innerHTML = updateEstimatedPosition(dataRow, estimatedPositionHTML);
      estimatedPosition.parentNode.appendChild(estimatedPositionResults);
    });

    if (results) {
      results.classList.remove('u-hide');
      app.classList.add('u-hide');
    }

    helpers.triggerEvent(doc, 'updatedResults');
  };

  /* ---------------------------------------------------------------------
   * 7. Form Submit
   * -------------------------------------------------------------------*/

  const modal = doc.querySelector('#simulatorModal');

  app.addEventListener('submit', (event) => {
    event.preventDefault();

    Array.prototype.forEach.call(getInputs(), (input) => {
      if (input.value) return;
      addNotice(input.parentNode, 'Preencha este campo.');
    });

    if (app.querySelector('.input-error')) return;

    if (helpers.getCookie('user_is_lead')) {
      ['basePosition', 'correctives', 'estimatedPosition'].forEach((elementClass) => {
        const resultRows = doc.querySelectorAll('.' + elementClass + '-result');
        Array.prototype.forEach.call(resultRows, (resultRow) => {
          if (resultRow === resultRows[0]) return;
          resultRow.parentNode.removeChild(resultRow);
        });
      });
      updateResults();
      return;
    }

    modal.classList.remove('u-hide');

    modal.addEventListener('click', (event) => {
      const target = event.target;
      ['lightbox-btn-close', 'lightbox-container'].forEach((elementClass) => {
        if (target.classList.contains(elementClass)) {
          modal.classList.add('u-hide');
        }
      });
    });

  });

  doc.addEventListener('simulator_form_sent', () => {
    helpers.setCookie('user_is_lead', 1, 1);
    modal.classList.add('u-hide');
    updateResults();
  });

  /* ---------------------------------------------------------------------
   * 8. Edit Samples
   * -------------------------------------------------------------------*/

  const btnEditSamples = doc.querySelector('.js-editSamples');
  if (btnEditSamples) {
    btnEditSamples.addEventListener('click', () => {
      const results = doc.querySelector('.appResult');
      results.classList.add('u-hide');
      app.classList.remove('u-hide');
    });
  }

  /* ---------------------------------------------------------------------
   * 9. Edit Samples
   * -------------------------------------------------------------------*/

  const btnPrintResults = doc.querySelector('.js-printResults');
  if (btnPrintResults) {
    btnPrintResults.addEventListener('click', () => {
      doc.body.classList.add('print-results');
      window.print();
    });
  }

}(document));
